var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [(typeof _vm.value !=='boolean')?_c('v-text-field',_vm._g(_vm._b({staticClass:"v-input--is-disabled",attrs:{"readonly":"","hide-details":"","label":_vm.label,"value":_vm.value}},'v-text-field',_vm.$attrs,false),on)):_vm._e()]}}])},[_vm._v(" "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }